{
  "base_password": "Mot de passe",
  "base_loading": "Chargement...",
  "base_item": "Article",
  "base_date": "Date",
  "base_hour": "Heure",
  "base_description": "Description",
  "base_value": "Valeur",
  "base_add": "Ajouter",
  "base_submit": "Envoyer",
  "base_product": "Produit",
  "base_confirm": "Confirmer",
  "base_quantity": "Qté",
  "base_cancel": "Annuler",
  "base_select": "Sélectionner",
  "base_code": "Code",
  "account_myPurchases": "Mes achats",
  "account_view": "Voir",
  "account_emptyNotice": "Aucun achat trouvé.",
  "account_previous": "Précédent",
  "account_next": "Suivant",
  "account_itemsQuantity": "{quantity} article(s)",
  "account_sellNumber": "Commande n° {orderCode}",
  "account_log_out_button": "Se déconnecter",
  "account_total_purchases": "Total",
  "account_sale_item_without_date": "Sans réservation",
  "account_sale_total_value": "Valeur totale",
  "account_sale_discount": "Remise",
  "account_sale_date": "Date et heure",
  "account_sale_reschedule": "Reprogrammer",
  "account_sale_reservation_tariff": "Tarifs",
  "account_sale_reservation_voucher": "Actions",
  "account_sale_reservation_places": "Places",
  "account_sale_checkout": "Paiement",
  "account_sale_download_all": "Tout télécharger",
  "account_sale_reschedule_disabled": "Il n'est pas possible de reprogrammer des réservations promotionnelles. Contactez l'établissement pour plus d'informations",
  "account_sale_reschedule_success_message": "Reprogrammation confirmée avec succès",
  "account_sale_voucher_revoketed": "Annulé",
  "account_empty_state": "Vous n'avez encore aucun achat",
  "account_sale_package_title": "{packageName} avec {quantity} activités",
  "account_sale_reschedule_tooltip": "Les réservations promotionnelles ne peuvent pas être reprogrammées. Contactez l'établissement pour plus d'informations.",
  "account_sale_voucher_pending": "Voucher en attente",
  "account_sale_pending_voucher_info": "Le paiement de votre achat a été confirmé. <strong>Le voucher est en cours de génération</strong> auprès du partenaire et sera bientôt disponible.",
  "account_sale_download_all_vouchers_tooltip": "Voucher en attente, attendez la confirmation",
  "account_sale_voucher_pending_status": "En attente de confirmation",
  "account_sale_change_amount": "Supplément de reprogrammation",
  "account_sale_original_total_value": "Valeur totale initiale de l'achat",
  "account_email_change_title": "Confirmation du changement d'e-mail",
  "account_email_change_confirm_title": "Vos données d'inscription ont été mises à jour.",
  "account_email_change_description": "Pour continuer, saisissez votre e-mail actuel. Nous validerons le code envoyé à la nouvelle adresse.",
  "account_email_change_confirm_description": "<strong><em>{app}</em></strong> a mis à jour vos données d'inscription.<br></br>Acceptez-vous que vos données soient mises à jour dans notre base ?",
  "account_email_change_current_email_label": "E-mail actuel",
  "account_email_change_new_email_label": "Nouvel e-mail",
  "account_email_change_login_button": "Continuer",
  "account_email_change_confirm_button": "J'accepte",
  "account_email_change_decline_button": "Je n'accepte pas",
  "account_email_change_success": "Changement d'e-mail confirmé avec succès.",
  "account_email_change_declined": "Le changement d'e-mail a été refusé.",
  "account_email_change_invalid_link": "Ce lien de confirmation est invalide ou incomplet.",
  "account_email_change_error": "Nous n'avons pas pu effectuer le changement d'e-mail. Réessayez ou demandez un nouveau lien.",
  "reservation_download": "Télécharger",
  "reservation_rescheduling": "Reprogrammation...",
  "voucher_download": "Télécharger",
  "reschedule_step_date": "Sélectionnez une date",
  "reschedule_step_time": "Sélectionnez un horaire",
  "reschedule_step_summary": "Confirmez la sélection",
  "reschedule_go_back_button": "Retour",
  "reschedule_confirm_button": "Confirmer",
  "reschedule_make_payment_button": "Effectuer le paiement",
  "reschedule_go_forward_button": "Continuer",
  "reschedule_selected_date": "Date sélectionnée",
  "reschedule_selected_time": "Horaire sélectionné",
  "reschedule_error_reschedulingLimitExceeded": "Limite de reprogrammations dépassée",
  "reschedule_error_reschedulingToHigherTariffNotAllowed": "Il n'est pas possible de reprogrammer vers un tarif supérieur",
  "reschedule_error_reschedulingToLowerTariffNotAllowed": "Il n'est pas possible de reprogrammer vers un tarif inférieur",
  "reschedule_error_reschedulingAntecedenceNotMet": "La reprogrammation doit être demandée au moins {minAntecedence} à l'avance",
  "reschedule_error_scheduleTimeMustDifferFromCurrent": "L'horaire sélectionné doit être différent de l'horaire actuel",
  "reschedule_error_schedulingIsValid": "La date sélectionnée n'est pas valide",
  "reschedule_error_invalidValue": "La date sélectionnée n'est pas valide",
  "reschedule_days": "{count, plural, one {{count, number} jour} other {{count, number} jours}}",
  "reschedule_hours": "{count, plural, one {{count, number} heure} other {{count, number} heures}}",
  "reschedule_minutes": "{count, plural, one {{count, number} minute} other {{count, number} minutes}}",
  "reschedule_charge_summary_alert_title": "Vérifiez que la nouvelle date est correcte",
  "reschedule_charge_summary_alert_description": "Votre réservation actuelle est prévue pour le {date}. Après confirmation, votre billet ne donnera plus accès à cette date et il vous restera {remainingRescheduleCount} reprogrammation.",
  "reschedule_charge_summary_actual_schedule": "Réservation actuelle",
  "reschedule_charge_summary_new_schedule": "Nouvelle réservation",
  "reschedule_charge_summary_total_to_pay": "Total à payer",
  "reschedule_charge_summary_disclaimer": "Votre réservation du {date} est garantie jusqu'à la confirmation de la reprogrammation.",
  "reschedule_charge_summary_pay_button": "Effectuer le paiement",
  "reschedule_info_remaining_reschedule_count": "Reprogrammations disponibles : ",
  "reschedule_info_reschedule_until_title": "Date limite de demande de reprogrammation : ",
  "reschedule_history_old_reservation_value": "Ancienne réservation : ",
  "reschedule_history_new_reservation_value": "Nouvelle réservation : ",
  "reschedule_applied_message": "Reprogrammation confirmée",
  "reschedule_expired_message": "Le paiement pour finaliser la reprogrammation a expiré",
  "reschedule_pending_payment_message": "Effectuez le paiement pour que la reprogrammation au {date} soit confirmée.",
  "reschedule_pending_payment_message_title": "Reprogrammation en attente",
  "reschedule_info_reschedule_until_expired": "Le délai de demande de reprogrammation a expiré",
  "reschedule_error_saleItemHasPayableSaleChanges": "La réservation a un paiement de reprogrammation en attente",
  "auth_processing": "Traitement...",
  "auth_checkoutHeaderTitle": "J'ai déjà un compte",
  "auth_accountHeaderTitle": "Connexion",
  "auth_alreadyHaveAnAccount": "J'ai déjà un compte",
  "auth_wantToSignup": "Je veux m'inscrire",
  "auth_signupPasswordInfo": "Il doit contenir au moins 8 caractères, dont au moins une majuscule, une minuscule et un chiffre.",
  "auth_inputEmail": "Saisissez votre e-mail",
  "auth_inputPassword": "Mot de passe",
  "auth_labelPassword": "Mot de passe",
  "auth_labelEmail": "E-mail",
  "auth_forgotPassword": "J'ai oublié mon mot de passe",
  "auth_login": "Connexion",
  "auth_submit": "Envoyer",
  "auth_registerMessage": "Vous n'avez pas de compte ? Inscrivez-vous",
  "auth_createAccount": "Créer un compte",
  "auth_labelName": "Prénom",
  "auth_labelSurname": "Nom",
  "auth_mailConfirmation": "Confirmez l'e-mail",
  "auth_passwordConfirmation": "Confirmez le mot de passe",
  "auth_cellphone": "Numéro de téléphone portable",
  "auth_identity_cpf": "CPF",
  "auth_identity_cnpj": "CNPJ",
  "auth_cep": "Code postal",
  "auth_corporate_name": "Raison sociale",
  "auth_cnpj_first_name": "Prénom du représentant légal",
  "auth_cnpj_last_name": "Nom du représentant légal",
  "auth_identity_passport": "Passeport",
  "auth_identity_national_document": "Document national",
  "auth_document": "Document",
  "auth_nationality": "Nationalité",
  "auth_birthdate": "Date de naissance",
  "auth_identity_type_cpf": "Je suis un particulier",
  "auth_identity_type_cnpj": "Je suis une personne morale",
  "auth_is_foreign": "Je suis étranger",
  "auth_termsRead": "J'ai lu et j'accepte les ",
  "auth_terms": "Conditions d'utilisation",
  "auth_termsAnd": " et la ",
  "auth_policy": "Politique de confidentialité",
  "auth_requiredCheckOfTermsAndPrivacyPolicy": "Vous devez accepter les Conditions et la Politique de confidentialité pour continuer.",
  "auth_terms_close": "fermer",
  "auth_terms_loading": "Chargement...",
  "auth_signup": "Inscription",
  "auth_recoverPassword": "Récupérer le mot de passe",
  "auth_backToLogin": "Retour à la connexion",
  "auth_code": "Code",
  "auth_resetPassword": "Réinitialiser le mot de passe",
  "auth_goBackButton": "Retour",
  "auth_loginSubtitle": "Nous n'utilisons que les données essentielles pour générer le voucher de consommation",
  "auth_passwordResetSubtitle": "Saisissez l'e-mail enregistré sur la plateforme pour récupérer le mot de passe",
  "auth_validCodeSubtitle": "Saisissez le code à 6 chiffres qui a été envoyé à",
  "auth_continue": "Continuer",
  "auth_didNotGetTheEmail": "Vous n'avez pas reçu l'e-mail ?",
  "auth_clickHere": "Cliquez ici",
  "auth_passwordRecoverySubtitle": "Saisissez votre nouveau mot de passe ci-dessous pour terminer la réinitialisation",
  "auth_redefinePassword": "Redéfinir le mot de passe",
  "auth_messagePasswordModifiedSuccessFully": "Votre mot de passe a été modifié avec succès !",
  "auth_resendEmailInfo": "Le code sera renvoyé à l'adresse e-mail suivante :",
  "auth_fixEmail": "Corriger l'e-mail",
  "auth_messageAccountCreatedSuccessFully": "Votre compte a été créé avec succès !",
  "auth_continueShopping": "Continuer mes achats",
  "auth_emailUniquenessError_title": "E-mail déjà enregistré",
  "auth_emailUniquenessError_message": "Nous avons identifié que vous vous êtes déjà inscrit auprès d'un établissement qui utilise la technologie d'e-commerce de Planne. Veuillez donc créer un nouveau mot de passe pour effectuer une connexion simplifiée.<br></br><br></br>Vos données sont en sécurité et ne sont partagées qu'avec les entreprises que vous avez autorisées.",
  "auth_emailUniquenessError_action": "Créer un nouveau mot de passe",
  "auth_zipCode_max_length_error": "Le code postal doit comporter 8 chiffres",
  "auth_verify_phone_form_title": "Saisissez la clé d'accès",
  "auth_verify_phone_form_subtitle": "Saisissez le code envoyé par SMS au numéro :",
  "auth_verify_phone_form_code": "Code",
  "auth_verify_phone_form_did_not_receive": "Vous n'avez pas reçu le SMS ?",
  "auth_verify_phone_form_resend": "Renvoyer",
  "auth_verify_phone_form_submit": "Continuer",
  "auth_verify_phone_form_back": "Retour",
  "auth_verify_phone_form_code_expires_in": "Vous pourrez demander un nouveau code à",
  "auth_invalid_verification_code": "Le code doit comporter 6 caractères",
  "checkout_confirmingYourPurchase": "Confirmation de votre achat...",
  "checkout_awaiting_confirmation_message": "Nous vérifions la disponibilité. Patientez un instant avant de payer.",
  "checkout_awaiting_confirmation_unavailable_title": "Disponibilité non disponible",
  "checkout_awaiting_confirmation_unavailable_description": "Nous n'avons pas pu confirmer votre réservation. Choisissez une autre date ou heure et réessayer.",
  "checkout_awaiting_confirmation_unavailable_action": "Choisir une autre date ou heure",
  "checkout_pendingSales": "Ventes en attente :",
  "checkout_saleNumber": "Vente n° {saleNumber}",
  "checkout_item": "Article",
  "checkout_totalValue": "Valeur totale :",
  "checkout_yourCartIsEmpty": "Votre panier est vide !",
  "checkout_yourCartErrors": "Le panier contient les erreurs suivantes :",
  "checkout_continueShopping": "Continuer mes achats",
  "checkout_finishSale": "Finaliser l'achat",
  "checkout_placement": "Places :",
  "checkout_resource_extra_value": "Supplément pour les places :",
  "checkout_additionals": "Suppléments",
  "checkout_invalidCoupon": "Voucher invalide",
  "checkout_removeCoupon": "Retirer le voucher",
  "checkout_couponCode": "Code du voucher",
  "checkout_addCoupon": "Ajouter un voucher de réduction",
  "checkout_processingPayment": "Veuillez patienter, le paiement est en cours de traitement...",
  "checkout_expiredSale": "Vente expirée",
  "checkout_makeYourPurchaseAgain": "Veuillez effectuer votre achat à nouveau.",
  "checkout_percentDiscount": "% de réduction",
  "checkout_unavailablePaymentOptions": "Options de paiement indisponibles",
  "checkout_unavailablePaymentMethod": "Moyen de paiement indisponible.",
  "checkout_securityCode": "Code de sécurité",
  "checkout_validityMonth": "Mois de validité",
  "checkout_validityYear": "Année de validité",
  "checkout_formInputPhonePlaceholder": "(99) 99999-9999",
  "checkout_formInputEmailPlaceholder": "votre@meilleuremail.com",
  "checkout_formInputCpfPlaceholder": "000.000.000-00",
  "checkout_paymentIn": "Payer en",
  "checkout_addressTitle": "Adresse",
  "checkout_addressZipCode": "Code postal (CEP)",
  "checkout_addressCountry": "Pays",
  "checkout_addressState": "État",
  "checkout_addressStateHint": "Uniquement le sigle. Ex. : RJ",
  "checkout_addressCity": "Ville",
  "checkout_addressDistrict": "Quartier",
  "checkout_addressStreet": "Rue",
  "checkout_addressNumber": "Numéro",
  "checkout_addressComplement": "Complément",
  "checkout_nameAsInCard": "Nom",
  "checkout_nameAsInCardHint": "Tel qu'il apparaît sur la carte",
  "checkout_identityMessage": "Numéro de CPF du titulaire de la carte (si vous laissez ce champ vide, le CPF/CNPJ {num} sera utilisé)",
  "checkout_expiredTry": "Votre tentative précédente a expiré, veuillez réessayer.",
  "checkout_fromValue": " De ",
  "checkout_toValue": " à ",
  "checkout_payWithPix": "Payer avec Pix",
  "checkout_copiedCode": "Code copié !",
  "checkout_finishPaymentWithPix": "Finalisez votre paiement avec Pix !",
  "checkout_pixUseCameraDescription": "Vous pouvez utiliser l'appareil photo de votre téléphone pour lire le QR Code ou copier le code et payer dans l'application de votre banque :",
  "checkout_verifyingPayment": "Vérification du paiement",
  "checkout_qrCodeWithPixCode": "QR Code avec le code Pix",
  "checkout_copyCode": "Copier le code",
  "checkout_completePurchaseStepsTitle": "Pour finaliser votre achat, suivez les étapes ci-dessous",
  "checkout_ongoingPixDescription": "Vous devez encore payer le Pix. Vous pouvez utiliser l'option de paiement par QR Code ou copier et coller le code et finaliser le paiement avec l'application de votre choix ou votre banque en ligne.",
  "checkout_remove": "Retirer",
  "checkout_confirm": "Confirmez le montant affiché, il doit obligatoirement être identique au montant facturé pour éviter l'annulation de la transaction, ainsi que les informations du bénéficiaire (nom de l'institution financière : ",
  "checkout_nameOfReceiver": "nom de l'entreprise bénéficiaire : ",
  "checkout_atention": "Attention :",
  "checkout_warning1": "<strong>N'effectuez pas le paiement avec la fonction Virement </strong> <span>, car la </span> <strong> transaction ne sera pas finalisée et le remboursement ne se fera pas automatiquement </strong> <span>, vous devrez alors contacter notre Centre d'assistance. </span>",
  "checkout_warning2": "<span>Le délai de confirmation du paiement est d'</span>  <strong> environ 10 secondes</strong>    <span> mais il dépend de l'institution financière, le temps de traitement peut donc être prolongé.</span>",
  "checkout_warning3": "<strong>Le QR Code est valable 5 minutes</strong> <span>. S'il n'est pas payé dans ce délai, vous devrez</span> <strong> générer un nouveau code Pix.</strong>",
  "checkout_units": "unité(s)",
  "checkout_method_softdescriptor": "Sur le relevé de la carte, cet achat apparaît au nom de",
  "checkout_cardNumber": "Numéro de la carte",
  "checkout_postalCode": "Code postal",
  "checkout_buyerInfoCollectHeaderTitle": "Informations complémentaires",
  "checkout_buyerInfoCollectSubtitle": "Nous utilisons uniquement les données essentielles pour générer le voucher de consommation",
  "checkout_buyerInfoCollectProceed": "Continuer",
  "checkout_buyerInfoCollectStepback": "Retour",
  "checkout_buyerInfoCollectFillWithSignupData": "Remplir avec les données indiquées lors de l'inscription",
  "checkout_tariff": "Tarif",
  "checkout_step_login": "Connexion",
  "checkout_step_signup": "Créer un compte",
  "checkout_step_personal": "Données personnelles",
  "checkout_step_payment": "Données de paiement",
  "checkout_step_payment_security_note": "Tous les achats effectués sur ce site sont 100% sécurisés, y compris vos données personnelles et les données de votre carte.",
  "checkout_purchase_summary": "Récapitulatif de l'achat",
  "checkout_order_summary_title": "Récapitulatif de la commande",
  "checkout_coupon_placeholder": "Coupon de réduction",
  "checkout_coupon_apply": "Appliquer",
  "checkout_coupon_affected_products": "Réduction appliquée uniquement aux produits :",
  "checkout_view_more": "Voir plus",
  "checkout_view_product_details": "Voir les détails des produits",
  "checkout_sold_by": "Vendu par",
  "checkout_tariffs_section": "Tarifs",
  "checkout_view_summary": "Voir le récapitulatif",
  "checkout_hide_summary": "Masquer le récapitulatif",
  "checkout_discounts": "Réductions",
  "checkout_cart_summary_total": "Total : {total}",
  "checkout_cart_summary_products": "({count, plural, one {{count, number} produit} other {{count, number} produits}})",
  "checkout_title": "Finaliser l'achat",
  "checkout_back_to_site": "Retour au site",
  "checkout_back": "Retour",
  "checkout_auth_identification_title": "Accédez à votre compte",
  "checkout_auth_identification_subtitle": "Créez ou accédez à votre compte",
  "checkout_auth_email_label": "E-mail",
  "checkout_auth_identification_cta": "Continuer",
  "checkout_auth_or_divider": "OU",
  "checkout_auth_required_field": "Champ obligatoire",
  "checkout_auth_invalid_email": "E-mail invalide",
  "checkout_auth_generic_error_title": "Impossible de continuer",
  "checkout_auth_generic_error": "Nous n'avons pas pu traiter votre demande pour le moment. Veuillez réessayer dans quelques instants.",
  "checkout_auth_generic_error_retry": "Réessayer",
  "checkout_auth_login_title": "Accédez à votre compte",
  "checkout_auth_login_existing_account_subtitle": "Cet e-mail est associé à un compte sur nos marketplaces. Saisissez votre mot de passe pour continuer ou, si vous préférez, recevez un code par e-mail pour continuer sans mot de passe.",
  "checkout_auth_login_password_subtitle": "Saisissez votre e-mail et votre mot de passe pour continuer ou, si vous préférez, recevez un code par e-mail pour continuer sans mot de passe.",
  "checkout_auth_login_otp_subtitle": "Nous avons envoyé un code à 6 chiffres à <strong>{email}</strong>, saisissez-le ci-dessous pour continuer.",
  "checkout_auth_password_label": "Mot de passe",
  "checkout_auth_show_password": "Afficher le mot de passe",
  "checkout_auth_hide_password": "Masquer le mot de passe",
  "checkout_auth_forgot_password_prefix": "Vous avez oublié votre mot de passe ?",
  "checkout_auth_forgot_password_link": "Cliquez ici pour le récupérer",
  "checkout_auth_continue_cta": "Continuer",
  "checkout_auth_continue_purchase_cta": "Continuer l'achat",
  "checkout_auth_login_with_code_cta": "Se connecter avec un code",
  "checkout_auth_login_with_password_cta": "Se connecter avec un mot de passe",
  "checkout_auth_otp_label": "Saisissez le code envoyé",
  "checkout_auth_otp_helper": "Nous avons envoyé un code à votre e-mail",
  "checkout_auth_otp_resend_countdown": "Renvoyer le code dans {seconds}s",
  "checkout_auth_otp_resend_cta": "Renvoyer le code",
  "checkout_auth_otp_sending": "Envoi du code...",
  "checkout_auth_signup_link": "Premier achat ? Inscrivez-vous",
  "checkout_auth_signup_title": "Créez votre compte",
  "checkout_auth_signup_subtitle": "Renseignez vos données pour continuer votre achat.",
  "checkout_auth_signup_identity_type_label": "Type de compte",
  "checkout_auth_signup_person_title": "Je suis un particulier",
  "checkout_auth_signup_person_subtitle": "J'utilise mon CPF",
  "checkout_auth_signup_company_title": "Je suis une entreprise",
  "checkout_auth_signup_company_subtitle": "J'utilise mon CNPJ",
  "checkout_auth_signup_first_name_label": "Prénom",
  "checkout_auth_signup_last_name_label": "Nom",
  "checkout_auth_signup_legal_first_name_label": "Prénom du représentant légal",
  "checkout_auth_signup_legal_last_name_label": "Nom du représentant légal",
  "checkout_auth_signup_corporate_name_label": "Raison sociale",
  "checkout_auth_signup_cpf_label": "CPF",
  "checkout_auth_signup_cnpj_label": "CNPJ",
  "checkout_auth_signup_phone_label": "Téléphone mobile",
  "checkout_auth_signup_legal_phone_label": "Téléphone mobile du représentant légal",
  "checkout_auth_signup_foreign_checkbox": "Je suis étranger",
  "checkout_auth_signup_nationality_label": "Nationalité",
  "checkout_auth_signup_foreign_document_label": "Document",
  "checkout_auth_signup_foreign_document_type_label": "Type de document",
  "checkout_auth_signup_foreign_document_identity": "Document national d'identité",
  "checkout_auth_signup_foreign_document_passport": "Passeport",
  "checkout_auth_signup_zip_code_label": "CEP",
  "checkout_auth_signup_postal_code_label": "Code postal (Facultatif)",
  "checkout_auth_signup_postal_code_hint": "Laissez vide si votre pays n'utilise pas de code postal.",
  "checkout_auth_signup_zip_code_help_link_label": "Je ne connais pas mon CEP",
  "checkout_auth_signup_zip_code_help_title": "Vous ne connaissez pas votre CEP ?",
  "checkout_auth_signup_zip_code_help_intro": "Nous utilisons votre CEP pour confirmer vos données en toute sécurité au moment du paiement.",
  "checkout_auth_signup_zip_code_help_tip_before": "Vérifiez sur une facture d'électricité ou d'eau récente, sur un courrier reçu, ou recherchez sur le",
  "checkout_auth_signup_zip_code_help_link": "site des Correios",
  "checkout_auth_signup_zip_code_help_tip_after": ".",
  "checkout_auth_signup_zip_code_help_close": "Fermer",
  "checkout_auth_signup_state_label": "État",
  "checkout_auth_signup_city_label": "Ville",
  "checkout_auth_signup_district_label": "Quartier",
  "checkout_auth_signup_street_label": "Rue",
  "checkout_auth_signup_number_label": "Numéro",
  "checkout_auth_signup_complement_label": "Complément",
  "checkout_auth_signup_password_confirmation_label": "Confirmer le mot de passe",
  "checkout_auth_signup_password_hint": "Au moins 8 caractères, avec une lettre majuscule, une lettre minuscule et un chiffre",
  "checkout_auth_signup_password_confirmation_hint": "Répétez le mot de passe",
  "checkout_auth_signup_terms_prefix": "J'ai lu et j'accepte les",
  "checkout_auth_signup_terms_of_use": "Conditions d'utilisation",
  "checkout_auth_signup_terms_connector": "et la",
  "checkout_auth_signup_privacy_policy": "Politique de confidentialité",
  "checkout_auth_signup_secure_purchase": "Achat 100% sécurisé",
  "checkout_auth_signup_confirm_cta": "Confirmer",
  "checkout_auth_signup_email_in_use_title": "E-mail déjà enregistré",
  "checkout_auth_signup_email_in_use_message": "Un compte avec cet e-mail existe déjà. Connectez-vous ou récupérez votre mot de passe pour continuer.",
  "checkout_auth_signup_email_in_use_login": "Se connecter",
  "checkout_auth_signup_email_in_use_recover": "Créer un mot de passe",
  "checkout_auth_signup_email_not_found_title": "Nous n'avons pas pu confirmer cet e-mail",
  "checkout_auth_signup_email_not_found_message": "Vérifiez qu'il est correctement saisi ou utilisez une autre adresse pour créer votre compte.",
  "checkout_auth_signup_invalid_cpf": "CPF invalide",
  "checkout_auth_signup_invalid_cnpj": "CNPJ invalide",
  "checkout_auth_signup_invalid_zip_code": "Le CEP doit comporter 8 chiffres",
  "checkout_auth_signup_invalid_phone": "Saisissez un numéro de téléphone mobile valide",
  "checkout_auth_signup_weak_password": "Le mot de passe doit comporter au moins 8 caractères, avec une lettre majuscule, une lettre minuscule et un chiffre",
  "checkout_auth_signup_password_mismatch": "Les mots de passe ne correspondent pas",
  "checkout_auth_signup_terms_required": "Vous devez accepter les conditions pour continuer",
  "checkout_auth_signup_recaptcha_required": "Confirmez que vous n'êtes pas un robot",
  "checkout_auth_signup_foreign_cnpj_conflict": "L'inscription en tant qu'entreprise n'est pas disponible pour les acheteurs étrangers",
  "auth_login_submit_cta": "Se connecter",
  "auth_login_password_subtitle": "Saisissez votre mot de passe pour accéder à votre compte.",
  "auth_login_signup_link": "Vous n'avez pas de compte ? Inscrivez-vous",
  "checkout_auth_signup_page_title": "Créez votre compte",
  "checkout_auth_reset_password_page_title": "Réinitialisation du mot de passe",
  "checkout_auth_recovery_title": "Récupération du mot de passe",
  "checkout_auth_recovery_email_subtitle": "Saisissez l'e-mail enregistré et nous vous enverrons un code à 6 chiffres pour vérifier votre identité.",
  "checkout_auth_recovery_otp_subtitle": "Nous avons envoyé un code à 6 chiffres à <strong>{email}</strong>. Saisissez-le ci-dessous pour poursuivre la récupération du mot de passe.",
  "checkout_auth_recovery_new_password_title": "Réinitialiser le mot de passe",
  "checkout_auth_new_password_label": "Nouveau mot de passe",
  "checkout_auth_confirm_password_label": "Confirmer le mot de passe",
  "checkout_auth_password_min_length_helper": "Votre mot de passe doit contenir au moins 8 caractères",
  "checkout_auth_password_repeat_helper": "Répétez le mot de passe",
  "checkout_auth_reset_password_cta": "Réinitialiser le mot de passe",
  "checkout_auth_back_cta": "Retour",
  "checkout_auth_did_not_receive_email": "Vous n'avez pas reçu l'e-mail ?",
  "checkout_auth_resend_email_link": "Cliquez ici pour renvoyer",
  "checkout_auth_otp_code_label": "Saisissez le code",
  "checkout_auth_otp_code_invalid": "Code incorrect. Vérifiez les caractères et réessayez.",
  "checkout_auth_email_placeholder": "Saisissez votre e-mail",
  "checkout_auth_password_mismatch": "Les mots de passe doivent être identiques",
  "checkout_auth_password_strength": "Le mot de passe doit contenir au moins 8 caractères, dont des majuscules, des minuscules et des chiffres",
  "checkout_pix_proceed_description": "Cliquez sur continuer pour générer le QR Code de paiement unique et poursuivre votre achat.",
  "checkout_continue_pix": "Continuer",
  "checkout_card_owner_cpf_cnpj": "CPF ou CNPJ du titulaire de la carte",
  "checkout_valid_date": "Date d'expiration (MM/AA)",
  "checkout_complete_purchase": "Finaliser l'achat",
  "checkout_disapproved_warning": "Attention !",
  "checkout_disapproved_intro": "Achat refusé",
  "checkout_disapproved_try_again": "Réessayer",
  "checkout_purchase_summary_day": "Jour",
  "checkout_purchase_summary_without_date": "Sans programmation",
  "checkout_payment_successful": "Paiement effectué avec succès",
  "checkout_payment_successful_redirect": "Voir l'achat",
  "checkout_payment_anti_fraud_error": "Vérifiez que les données sont correctes ou utilisez un autre moyen de paiement.",
  "checkout_payment_transaction_error": "Vérifiez que les données sont correctes ou contactez la banque émettrice de la carte.",
  "checkout_payment_generic_transaction_error": "Une erreur s'est produite lors du traitement de votre transaction. Veuillez patienter quelques instants et réessayer.",
  "checkout_payment_unauthorized_error": "Session expirée. Veuillez vous identifier et réessayer.",
  "checkout_payment_discount_chip": "{percentage}% de réduction",
  "checkout_payment_installments_chip": "Jusqu'à {count}x sans frais",
  "checkout_payment_card_number": "Numéro de carte",
  "checkout_payment_card_holder": "Nom du titulaire",
  "checkout_payment_card_holder_identity": "CPF ou CNPJ du titulaire",
  "checkout_payment_card_zip_code": "Code postal (CEP)",
  "checkout_payment_card_postal_code": "Code postal",
  "checkout_payment_card_security_code": "Code de sécurité (CVV)",
  "checkout_payment_card_installments": "Nombre de mensualités",
  "checkout_secure_purchase": "Achat 100% sécurisé",
  "checkout_additional_info_invalid_cpf": "CPF invalide",
  "checkout_additional_info_invalid_phone": "Numéro de téléphone invalide",
  "checkout_additional_info_invalid_date": "Date invalide",
  "checkout_additional_info_title": "Renseignez les informations importantes concernant votre réservation",
  "checkout_additional_info_subtitle": "Nous utilisons uniquement les données essentielles pour générer votre voucher",
  "checkout_additional_info_fill": "Renseigner les informations",
  "checkout_additional_info_edit": "Modifier",
  "checkout_additional_info_review": "Vérifier",
  "checkout_additional_info_filled": "Renseigné",
  "checkout_additional_info_not_filled": "Non renseigné",
  "checkout_additional_info_partially_filled": "{filled} sur {total} renseignés",
  "checkout_additional_info_needs_review": "Vérifiez les informations",
  "checkout_additional_info_continue": "Continuer",
  "checkout_additional_info_next": "Suivant",
  "checkout_additional_info_done": "Terminer",
  "checkout_additional_info_save": "Enregistrer",
  "checkout_additional_info_cancel": "Annuler",
  "checkout_additional_info_error_alert": "Vérifiez les informations signalées",
  "checkout_additional_info_progress": "{filled}/{total}",
  "checkout_payment_card_submit": "Finaliser l'achat",
  "checkout_payment_card_validity_must_be_valid": "La date d'expiration doit être au format MM/AA",
  "checkout_payment_card_foreign_alert_title": "Achats internationaux",
  "checkout_payment_card_foreign_alert_description": "Votre banque peut bloquer les achats internationaux. Activez « Avis de voyage » ou « Utilisation internationale » dans l'application de votre banque. La banque peut également demander une confirmation pour autoriser l'achat.",
  "checkout_payment_pix_step_generate": "Cliquez sur <strong>Générer le code Pix</strong> pour poursuivre votre achat",
  "checkout_payment_pix_step_confirm": "Vérifiez les informations et effectuez le paiement depuis l'application de votre banque",
  "checkout_payment_pix_secure_purchase": "Achat 100% sécurisé",
  "checkout_payment_pix_generate_button": "Générer le code Pix",
  "checkout_payment_pix_change_method": "Modifier le moyen de paiement",
  "checkout_payment_pix_change_method_compact": "Changer de moyen de paiement",
  "checkout_payment_pix_title": "Payez avec Pix",
  "checkout_payment_pix_description": "Vous pouvez utiliser l'appareil photo de votre téléphone pour lire le QR Code ou copier le code et payer dans l'application de votre banque.",
  "checkout_payment_pix_time_remaining": "Temps restant pour payer :",
  "checkout_payment_pix_copy_button": "Copier le code",
  "checkout_payment_pix_copied_tooltip": "Code Pix copié",
  "checkout_payment_pix_how_to_title": "Comment payer avec Pix :",
  "checkout_payment_pix_how_to_1": "Ouvrez l'application ou le site de la banque de votre choix.",
  "checkout_payment_pix_how_to_2": "Choisissez l'option « payer avec Pix Copier et Coller » ou QR Code.",
  "checkout_payment_pix_how_to_3": "Copiez et collez le code ou scannez le QR Code ;",
  "checkout_payment_pix_how_to_4": "Patientez quelques secondes. Votre commande sera confirmée dès que le paiement sera effectué",
  "checkout_payment_pix_expired_title": "Le code Pix a expiré",
  "checkout_payment_pix_expired_description": "Si vous avez déjà effectué le paiement, votre commande peut mettre jusqu'à 5 minutes pour être confirmée",
  "checkout_payment_pix_expired_retry": "Réessayer",
  "checkout_payment_pix_receiver_disclaimer": "Lors du paiement du Pix, le nom de l'établissement apparaîtra comme « <strong>{institution}</strong> »",
  "checkout_payment_account_title": "Compte",
  "checkout_payment_account_edit": "Modifier",
  "checkout_payment_step_title": "Paiement",
  "checkout_payment_step_subtitle": "Choisissez une option de paiement :",
  "checkout_phone_verification_alert_message": "Vous devez confirmer votre numéro de téléphone",
  "checkout_phone_verification_alert_button": "Confirmer",
  "checkout_sale_change_previous_reservation": "Réservation actuelle",
  "checkout_sale_change_new_reservation": "Nouvelle réservation",
  "checkout_confirmed_greeting": "Merci, {name} !",
  "checkout_confirmed_title": "Paiement confirmé",
  "checkout_confirmed_description": "Vous pouvez dès maintenant télécharger vos vouchers. Ils ont également été envoyés par e-mail et restent disponibles dans votre compte dès que vous en avez besoin",
  "checkout_confirmed_additionals": "Suppléments",
  "checkout_confirmed_additionals_overflow": "+{count}",
  "checkout_confirmed_additionals_show_more": "Voir plus",
  "checkout_confirmed_reschedule": "Reprogrammer",
  "checkout_confirmed_reschedule_available": "Reprogrammations disponibles : <span>{count}</span>",
  "checkout_confirmed_reschedule_deadline": "Délai pour demander une reprogrammation : <span>{deadline}</span>",
  "checkout_confirmed_reschedule_deadline_antecedence": "Jusqu'à {antecedence} avant la réservation",
  "checkout_confirmed_reschedule_expired": "Le délai pour reprogrammer a expiré",
  "checkout_confirmed_reschedule_unavailable": "Les réservations promotionnelles ne peuvent pas être reprogrammées. Contactez l'établissement pour plus d'informations.",
  "checkout_confirmed_reschedule_package_tooltip": "Les réservations d'un forfait sont reprogrammées ensemble. Contactez l'établissement.",
  "checkout_confirmed_vouchers_count": "Vouchers : {count}",
  "checkout_confirmed_vouchers_view_all": "Voir tous",
  "checkout_confirmed_vouchers_pending_tooltip": "Les vouchers sont encore en cours d'émission. Réessayez dans quelques instants.",
  "checkout_confirmed_download_all_vouchers": "Télécharger tous les vouchers",
  "checkout_order_details_title": "Détails de la commande",
  "checkout_order_details_email": "E-mail",
  "checkout_order_details_account_type": "Type de compte",
  "checkout_order_details_account_type_individual": "Particulier",
  "checkout_order_details_account_type_company": "Entreprise",
  "checkout_order_details_first_name": "Prénom",
  "checkout_order_details_last_name": "Nom",
  "checkout_order_details_representative_first_name": "Prénom du représentant légal",
  "checkout_order_details_representative_last_name": "Nom du représentant légal",
  "checkout_order_details_corporate_name": "Raison sociale",
  "checkout_order_details_country": "Pays d'origine",
  "checkout_order_details_cpf": "CPF",
  "checkout_order_details_cnpj": "CNPJ",
  "checkout_order_details_national_document": "Document national",
  "checkout_order_details_passport": "Passeport",
  "checkout_order_details_phone": "Téléphone portable",
  "checkout_order_details_payment_method": "Moyen de paiement",
  "checkout_order_details_installments": "Nombre de mensualités",
  "checkout_order_details_installments_value": "{count}x de {amount}",
  "checkout_order_details_zip_code": "Code postal",
  "checkout_payment_method_credit_card": "Carte de crédit",
  "checkout_payment_method_debit_card": "Carte de débit",
  "checkout_payment_method_pix": "Pix",
  "checkout_payment_method_post_paid": "Facturé",
  "checkout_vouchers_modal_code": "Code",
  "checkout_vouchers_modal_password": "Mot de passe",
  "checkout_vouchers_modal_status": "Statut",
  "checkout_vouchers_modal_status_open": "Non utilisé",
  "checkout_vouchers_modal_status_consumed": "Utilisé",
  "checkout_vouchers_modal_status_revoked": "Annulé",
  "checkout_vouchers_modal_status_pending": "En attente de confirmation",
  "checkout_vouchers_modal_download": "Télécharger le voucher",
  "checkout_vouchers_modal_tariff_quantity": "{count}x {name}",
  "checkout_payment_gateway_mismatch_error_title": "Impossible de procéder au paiement",
  "checkout_payment_gateway_mismatch_error_description": "Une erreur est survenue dans les informations financières du responsable de la vente. Pour poursuivre votre achat, contactez notre support.",
  "checkout_payment_gateway_mismatch_error_ok": "OK",
  "checkout_payment_gateway_blocked_buyer_error_title": "Impossible de traiter le paiement",
  "checkout_payment_gateway_blocked_buyer_error_helper_text": "Vous avez dépassé le nombre maximal de tentatives. Pour poursuivre votre achat, utilisez un autre moyen de paiement",
  "checkout_error_foreignCustomerNotAllowed": "Cette application n'autorise pas les achats depuis l'étranger. Veuillez contacter l'établissement pour plus d'informations.",
  "checkout_foreign_buyer_alert_badge": "IMPORTANT",
  "checkout_foreign_buyer_alert_title": "Achats internationaux",
  "checkout_foreign_buyer_alert_description": "Votre banque peut bloquer les achats internationaux. Activez <strong>« Avis de voyage »</strong> ou <strong>« Utilisation internationale »</strong> dans l'application de votre banque. La banque peut également demander <strong>une confirmation pour autoriser l'achat.</strong>",
  "timeout_error_title": "Impossible de communiquer avec le serveur",
  "timeout_error_description": "Oups, nous avons rencontré un problème de communication avec le serveur. Veuillez patienter quelques instants et réessayer.",
  "timeout_error_ok": "OK",
  "checkout_pix_payment_insufficient_amount_title": "Montant insuffisant pour le paiement via Pix",
  "checkout_pix_payment_insufficient_amount_description": "Ajoutez d'autres produits au panier ou utilisez un autre moyen de paiement",
  "adder_dataSelected": "Date sélectionnée : ",
  "adder_buy": "Acheter",
  "adder_goBack": "retour",
  "adder_quantity": "Quantité",
  "adder_hour": "Sélectionnez un horaire",
  "adder_unavailableQuantity": "Quantité non disponible",
  "adder_outOfStock": "Épuisé",
  "adder_additionals": "Suppléments",
  "adder_additionals_perPerson": "p/ tarif",
  "adder_additionals_remain": "Restant",
  "adder_additionals_soldOff": "Épuisé",
  "adder_productAddedToCart": "Produit ajouté au panier !",
  "adder_productNotAddedToCart": "Erreur lors de l'ajout du produit au panier",
  "adder_seeCart": "Voir mon panier",
  "adder_perPerson": "par personne",
  "adder_singleErrorLabel": "La quantité sélectionnée pour ce tarif n'est pas disponible",
  "adder_multipleErrorLabel": "La quantité des tarifs sélectionnés a dépassé la limite pour cette date",
  "adder_dependent_tariff": "Dépendant",
  "adder_dependent_tariff_selection_error": "Sélectionnez au moins un tarif non dépendant pour continuer",
  "adder_hours_unavailable_error": "Horaires non disponibles pour la quantité de tarifs sélectionnés",
  "adder_additionals_custom_type_quantity_placeholder": "Saisissez la quantité souhaitée",
  "adder_additionals_custom_type_quantity_error": "La quantité doit être supérieure à zéro",
  "adder_additionals_custom_type_max_quantity_error": "La quantité maximale autorisée est {maxQuantity}",
  "adder_seats_missing_tariffs_unavailable_error": "Nous n'avons pas trouvé de places disponibles pour ces tarifs et cet horaire sélectionnés. Pour continuer, ajoutez {missing} tarif(s) supplémentaire(s) à votre sélection ou essayez un autre horaire disponible.",
  "adder_seats_unavailable_error": "Nous n'avons pas trouvé de places disponibles pour les tarifs et l'horaire sélectionnés. Pour continuer, sélectionnez une autre date/heure disponible.",
  "adder_error_generic": "Impossible d'ajouter cette sélection au panier. Vérifiez les informations et réessayez.",
  "adder_error_tariff_quantity_limit": "La quantité sélectionnée dépasse la limite autorisée pour ce tarif. Réduisez la quantité pour continuer.",
  "adder_error_tariff_unavailable": "Il n'y a pas de disponibilité pour la quantité sélectionnée. Réduisez la quantité ou choisissez une autre date/heure.",
  "adder_error_additional_unavailable": "Il n'y a pas de disponibilité pour les suppléments sélectionnés. Vérifiez votre sélection pour continuer.",
  "adder_error_schedule_unavailable": "La date ou l'horaire sélectionné n'est plus disponible. Choisissez une autre option pour continuer.",
  "adder_error_seats_unavailable": "Il n'y a pas assez de places pour la quantité sélectionnée. Réduisez la quantité ou choisissez un autre horaire.",
  "adder_error_seats_missing_capacity": "Il manque {missing} place(s) pour la quantité sélectionnée à cet horaire. Réduisez la quantité ou choisissez un autre horaire.",
  "adder_error_product_unavailable": "Ce produit n'est pas disponible à l'achat pour le moment.",
  "adder_tariff_verification_field_required": "Ce champ est obligatoire",
  "adder_tariff_verification_validation_error": "Données de justificatif invalides",
  "adder_tariff_verification_document_validation_error": "Le numéro de document fourni n'est pas valide ou ne répond pas aux critères exigés pour ce tarif.",
  "adder_tariff_verification_date_validation_error": "La date de naissance fournie ne répond pas aux critères exigés pour ce tarif.",
  "sale_totalValue": "Montant total : ",
  "sale_termExpired": "Le délai de paiement de cette commande a expiré.",
  "sale_printAll": "Tout imprimer",
  "sale_print": "Imprimer",
  "sale_productColumn": "Produit",
  "sale_dateColumn": "Date",
  "sale_hourColumn": "Heure",
  "sale_quantityColumn": "Qté",
  "sale_codeColumn": "Voucher",
  "sale_passwordColumn": "Mot de passe",
  "sale_stateColumn": "État",
  "sale_noAvailableReservation": "Aucune réservation disponible !",
  "sale_reschedule": "Reprogrammer",
  "sale_unavailableReschedule": "Reprogrammation indisponible !",
  "sale_awaitingDate": "En attente d'une date...",
  "sale_consumed": "Consommé",
  "sale_open": "Ouvert",
  "sale_goBack": "Retour",
  "seatMap_selectOneTime": "Sélectionnez un seul horaire",
  "seatMap_tariffUnits": "Unité(s)",
  "seatMap_pendingAllocationQuantity": "Quantité attribuée :",
  "seatMap_pendingTariffAllocation": "Certains tarifs n'ont pas encore été attribués",
  "seatMap_resourceMinValue": "Valeur de la place",
  "seatMap_filledCapacity": "places",
  "seatMap_resourceSubAllocationNotice": "Le nombre de tarifs attribués à la table est inférieur au minimum autorisé, veuillez sélectionner une autre table.",
  "seatMap_resourceReservationPrice": "Supplément pour les places",
  "seatMap_totalPrice": "Total",
  "seatMap_canvas_subtitles": "Légendes",
  "seatMap_tariff_price_cents": "Valeur des tarifs",
  "seatMap_selectSeat": "Sélectionnez la place",
  "awaiting_confirmation": "En attente de confirmation",
  "created": "Ouvert",
  "pending": "En attente",
  "expired": "Expiré",
  "confirmed": "Confirmé",
  "payment_complete": "Paiement confirmé",
  "payment_voided": "Paiement annulé",
  "payment_chargeback": "Annulé",
  "payment_charged_back": "Annulé",
  "payment_denied": "Annulé",
  "canceled": "Annulé",
  "available": "Disponible",
  "selected": "Sélectionné",
  "blocked": "Bloqué",
  "unavailable": "Indisponible",
  "no_option_found": "Aucune option trouvée",
  "january": "Janvier",
  "february": "Février",
  "march": "Mars",
  "april": "Avril",
  "may": "Mai",
  "june": "Juin",
  "july": "Juillet",
  "august": "Août",
  "september": "Septembre",
  "october": "Octobre",
  "november": "Novembre",
  "december": "Décembre",
  "monday": "Lundi",
  "tuesday": "Mardi",
  "wednesday": "Mercredi",
  "thursday": "Jeudi",
  "friday": "Vendredi",
  "saturday": "Samedi",
  "sunday": "Dimanche",
  "cart_item_remove_error": "Erreur lors de la suppression de l'article du panier. Veuillez réessayer ou contacter l'établissement.",
  "cart_package_error": "Un article a été modifié ou supprimé par le vendeur, veuillez le retirer du panier",
  "cart_package_details": "Détails des produits",
  "cart_item_price_summary_previous": "Prix précédent",
  "cart_iconLabel": "Votre panier contient {quantity} articles",
  "cart_loading": "Chargement du panier",
  "cart_header": "Panier",
  "cart_totalLabel": "Total",
  "cart_subtotal": "Sous-total",
  "cart_final_value": "Montant final",
  "cart_coupon_text": "Coupon",
  "cart_itemErrorWarning": "Cet article a été modifié par le fournisseur. Retirez-le du panier.",
  "discount_fallback_warning_message": "La remise de ce produit a été modifiée par le vendeur",
  "cart_value": "Valeur",
  "cart_checkout": "Finaliser l'achat",
  "cart_discount": "Remise",
  "cart_apply": "Appliquer",
  "cart_cancel": "Retirer",
  "cart_openAreaApplyVoucher": "Ouvrir la zone pour appliquer le code du voucher",
  "cart_closeAreaApplyVoucher": "Fermer la zone du code du voucher",
  "cart_voucherTitle": "Voucher de réduction",
  "cart_selectedDate": "Date",
  "cart_selectedLanguage": "Langue",
  "cart_selectedTariff": "Tarif",
  "cart_selectedResources": "Place sélectionnée",
  "cart_additionals": "Suppléments",
  "cart_itens": "Articles",
  "cart_backToHome": "Retour à la page d'accueil",
  "cart_pleaseWait": "Veuillez patienter !",
  "cart_yourCartIsEmpty": "Votre panier est vide",
  "cart_addProductInstruction": "Ajoutez un produit au panier",
  "cart_closeCart": "Fermer la fenêtre du panier",
  "cart_quantity": "Quantité",
  "cart_remove_discount_button": "Retirer",
  "cart_discount_coupon_button_title": "Ajouter un coupon de réduction",
  "cart_discount_coupon_submit_button": "AJOUTER",
  "cart_discount_coupon_applied_succefully": "Coupon de réduction appliqué",
  "cart_discount_coupon_product": "Uniquement pour le produit :",
  "cart_discount_coupon_product_list": "Uniquement pour les produits :",
  "cart_package_date": "Date :",
  "cart_package_tariff": "Tarifs :",
  "cart_package_previous_price": "Prix précédent",
  "cart_package_discount": "Remise",
  "cart_package_total": "Total",
  "cart_package_product_details": "Détails du produit",
  "adder_step_calendar": "Sélectionnez une date",
  "adder_step_tariff": "Sélectionnez un tarif",
  "adder_step_seat_map": "Sélectionnez une place",
  "adder_selected_date": "Date sélectionnée",
  "adder_step_additional": "Sélectionnez les suppléments",
  "adder_step_finish": "Ajouter au panier",
  "adder_step_package_quantity": "Sélectionnez une quantité",
  "adder_priceAccordingToSchedule": "selon l'horaire",
  "adder_day": "Jour",
  "adder_night": "Nuit",
  "adder_price_per_unit": "Prix par unité",
  "adder_goBackFooter": "Retour",
  "adder_goForwardsFooter": "Continuer",
  "adder_purchaseButton": "Acheter",
  "adder_serviceFee": "Des frais de service peuvent être appliqués",
  "adder_selectedTariff": "Tarif sélectionné",
  "adder_selectedResources": "Place sélectionnée",
  "adder_legend_current": "Jour en cours",
  "adder_legend_available": "Disponible",
  "adder_legend_unavailable": "Indisponible",
  "adder_legend_suggested_prices": "Prix susceptibles de changer",
  "adder_legend_suggested_prices_tooltip": "Le prix affiché peut varier selon l'horaire ou le tarif choisi",
  "adder_legend_busy": "Haute saison",
  "adder_unavailableTariffNotice": "Épuisé",
  "adder_tryAgain": "Réessayer",
  "adder_price_from": "De",
  "adder_price_to": "À",
  "adder_updating_price": "Mise à jour…",
  "adder_price_update_failed": "Impossible de mettre à jour le prix. Affichage de la dernière valeur.",
  "terms_of_use": "Conditions d'utilisation",
  "privacy_policy": "Politique de confidentialité",
  "direct_link_sale_title": "Panier",
  "direct_link_payment_title": "Paiement",
  "direct_link_pay_button": "Payer",
  "direct_link_finished_payment_message": "Paiement finalisé",
  "direct_link_finished_sale_message": "Achat finalisé",
  "direct_link_cancelled_message": "Lien annulé",
  "direct_link_checkout_error_couponHasUsesLeft": "Le coupon utilisé dans le panier n'a plus d'utilisations disponibles. Veuillez contacter l'établissement pour plus d'informations.",
  "direct_link_checkout_error_resourceMustBeAvailable": "Place non disponible",
  "direct_link_checkout_error_tariffOccupationMustBeRespected": "Il n'y a plus de places disponibles pour ce tarif à l'horaire choisi",
  "coupon_code": "Coupon invalide !",
  "coupon_expires_at": "Coupon expiré",
  "coupon_max_use": "Le coupon a dépassé le nombre maximum d'utilisations",
  "coupon_max_use_per_user": "Oups ! Vous avez déjà utilisé ce coupon le nombre maximum de fois autorisé",
  "coupon_invalid_for_these_products": "Coupon non applicable aux produits sélectionnés.",
  "open_purchase_title": "Finaliser le paiement",
  "open_purchase_description": "Vous avez un achat non finalisé, souhaitez-vous continuer ?",
  "open_purchase_button_text": "Oui",
  "direct_link_required_field": "Champ obligatoire",
  "customer_form_invalid_document": "Document invalide",
  "customer_form_email_does_not_match": "L'e-mail ne correspond pas",
  "customer_form_invalid_birthdate": "Date de naissance invalide",
  "direct_link_invalid_message": "Lien invalide",
  "direct_link_expired_message": "Lien expiré",
  "direct_link_auth_step_title": "Coordonnées",
  "direct_link_payment_step_title": "Paiement",
  "direct_link_summary_title_payment": "Résumé du paiement",
  "direct_link_summary_title_sale": "Résumé de l'achat",
  "direct_link_auth_message": "Vos billets seront envoyés à l'adresse e-mail indiquée. Veuillez saisir une adresse e-mail valide",
  "direct_link_auth_email_label": "E-mail",
  "direct_link_auth_continue": "Continuer",
  "direct_link_auth_login_title": "Se connecter",
  "direct_link_auth_login_or": "Ou",
  "direct_link_auth_login_with_otp": "Se connecter avec une clé d'accès",
  "direct_link_auth_login_with_password": "Se connecter avec un mot de passe",
  "direct_link_user_form_email_label": "E-mail",
  "direct_link_user_form_email_confirmation_label": "Confirmer l'e-mail",
  "direct_link_user_form_name_label": "Prénom",
  "direct_link_user_form_representative_legal_name_label": "Prénom du représentant légal",
  "direct_link_user_form_lastname_label": "Nom",
  "direct_link_user_form_representative_legal_lastname_label": "Nom du représentant légal",
  "direct_link_user_form_phone_label": "Téléphone",
  "direct_link_user_form_cpf_identity_label": "CPF",
  "direct_link_user_form_cnpj_identity_label": "CNPJ",
  "direct_link_user_form_identity_label": "CPF/CNPJ",
  "direct_link_user_form_birthday_label": "Date de naissance",
  "direct_link_user_form_zip_code_label": "Code postal",
  "direct_link_user_form_corporate_name_label": "Raison sociale",
  "direct_link_user_form_terms_message": "En poursuivant votre achat, vous déclarez accepter les ",
  "direct_link_user_form_terms_message_use_terms": "Conditions d'utilisation",
  "direct_link_user_form_terms_message_and": " et les ",
  "direct_link_user_form_terms_message_privacy_policy": "Politiques de confidentialité",
  "direct_link_user_form_continue": "Continuer",
  "direct_link_user_form_identity_type_cpf": "Je suis un particulier",
  "direct_link_user_form_identity_type_cnpj": "Je suis une personne morale",
  "direct_link_user_form_corporate_name": "Raison sociale",
  "direct_link_user_form_is_foreign": "Je suis étranger",
  "direct_link_user_form_nationality": "Nationalité",
  "direct_link_user_form_document": "Document",
  "direct_link_user_form_identity_national_document": "Document national",
  "direct_link_user_form_identity_passport": "Passeport",
  "direct_link_password_form_title": "Saisissez le mot de passe pour vous connecter",
  "direct_link_password_form_password_label": "Mot de passe",
  "direct_link_password_form_login": "Se connecter",
  "direct_link_password_form_forgot_password": "Mot de passe oublié ?",
  "direct_link_forgot_password_modal_title": "Réinitialiser le mot de passe",
  "direct_link_reset_password_form_title": "Saisissez le code que nous vous avons envoyé par e-mail",
  "direct_link_reset_password_code_label": "Code d'accès",
  "direct_link_reset_password_code_expires": "Le code expire dans",
  "direct_link_reset_password_sending_code": "Envoi du code...",
  "direct_link_reset_password_resend_code": "Renvoyer le code",
  "direct_link_reset_password_cancel": "Annuler",
  "direct_link_reset_password_confirm": "Confirmer",
  "direct_link_change_password_form_title": "Saisissez le nouveau mot de passe",
  "direct_link_change_password_form_password_label": "Nouveau mot de passe",
  "direct_link_change_password_form_password_confirmation_label": "Confirmer le nouveau mot de passe",
  "direct_link_change_password_form_cancel": "Annuler",
  "direct_link_change_password_form_confirm": "Confirmer",
  "direct_link_change_password_password_match": "Les mots de passe ne correspondent pas",
  "direct_link_auth_login_otp_form_title": "Saisissez le code que nous vous avons envoyé par e-mail",
  "direct_link_auth_login_otp_form_code_label": "Code d'accès",
  "direct_link_auth_login_otp_form_login": "Se connecter",
  "direct_link_auth_login_otp_form_code_expires": "Le code expire dans",
  "direct_link_auth_login_otp_form_sending_code": "Envoi du code...",
  "direct_link_auth_login_otp_form_resend_code": "Renvoyer le code",
  "direct_link_summary_date_and_time": "Date et heure",
  "direct_link_summary_subtotal": "Sous-total",
  "direct_link_summary_coupon": "Coupon",
  "direct_link_summary_discount": "Remise",
  "direct_link_summary_total": "Total",
  "direct_link_validate_phone_message": "Vous devez valider votre téléphone",
  "direct_link_validate_phone_validate": "Valider",
  "direct_link_validate_phone_modal_title": "Indiquer la clé d'accès",
  "direct_link_phone_verification_form_title": "Saisissez le code que nous vous avons envoyé par SMS sur votre téléphone :",
  "direct_link_phone_verification_form_code_label": "Code d'accès",
  "direct_link_phone_verification_form_code_expires": "Le code expire dans",
  "direct_link_phone_verification_form_sending_code": "Envoi du code...",
  "direct_link_phone_verification_form_resend_code": "Renvoyer le code",
  "direct_link_phone_verification_form_submit": "Continuer",
  "direct_link_card_form_submit": "Finaliser l'achat",
  "direct_link_card_form_identity_must_be_valid": "Le numéro doit être valide",
  "direct_link_card_form_postal_code_must_be_valid": "Le code postal doit être valide",
  "direct_link_card_form_postal_code_must_have_8_digits": "Le code postal doit contenir 8 chiffres",
  "direct_link_card_form_card_number_must_be_valid": "La carte doit être valide",
  "direct_link_card_form_card_brand_not_accepted": "Cette marque de carte n'est pas acceptée",
  "direct_link_card_form_card_expired": "La carte ne peut pas être expirée",
  "direct_link_card_form_validity_placeholder": "MM/AA",
  "direct_link_card_form_holder_helper": "Tel qu'indiqué sur la carte",
  "direct_link_pix_form_step_1_title": "Vous allez payer avec PIX",
  "direct_link_pix_form_step_1_description": "La confirmation du paiement ne prend que quelques minutes. Utilisez l'application de votre banque pour payer.",
  "direct_link_pix_form_step_1_pix_amount": "Montant en PIX :",
  "direct_link_pix_form_step_1_finish": "Finaliser l'achat",
  "direct_link_pix_form_step_2_instruction": "Ouvrez votre application de paiement et choisissez l'option <strong>Lire le QR Code</strong>",
  "direct_link_pix_form_step_2_camera_instruction": "Pointez la caméra de votre téléphone vers le QR Code",
  "direct_link_pix_form_step_2_copy_code": "Copier le code",
  "direct_link_pix_form_step_2_code_copied": "Copié !",
  "direct_link_pix_form_step_2_verifying_payment": "Vérification du paiement",
  "direct_link_pix_form_steps_step_1": "Finalisez l'achat en cliquant sur \"Finaliser l'achat\"",
  "direct_link_pix_form_steps_step_2": "Lisez le QR Code avec l'application de votre banque ou copiez la clé PIX",
  "direct_link_pix_form_steps_step_3": "Après la confirmation du paiement, votre réservation sera confirmée",
  "direct_link_payment_success_alert": "Paiement effectué !",
  "direct_link_payment_success_message": "Nous avons le plaisir de vous informer que votre paiement a bien été reçu.",
  "direct_link_payment_success_voucher_message": "Pour plus de détails, téléchargez votre voucher.",
  "direct_link_payment_success_download_vouchers": "Télécharger tous les vouchers",
  "direct_link_min_code_length": "Le code doit contenir au moins 6 caractères",
  "direct_link_max_code_length": "Le code doit contenir au maximum 6 caractères",
  "direct_link_min_password_length": "Le mot de passe doit contenir au moins 8 caractères",
  "direct_link_password_strength": "Le mot de passe doit contenir au moins 8 caractères, dont au moins une lettre majuscule, une lettre minuscule et un chiffre.",
  "direct_link_user_form_terms_modal_title": "Conditions d'utilisation",
  "direct_link_user_form_privacy_policy_modal_title": "Politiques de confidentialité",
  "direct_link_zipCode_max_length_error": "Le code postal doit contenir 8 chiffres",
  "cashback_growth_modal_title": "Votre achat a généré du cashback !",
  "cashback_growth_modal_store_hint": "Utilisable dans les <strong>parcs</strong>, les <strong>restaurants</strong> et les <strong>excursions partenaires</strong>.",
  "cashback_growth_modal_deadline": "Récupérez votre cashback via WhatsApp. Le délai pour l'utiliser commence au moment où vous le récupérez.",
  "cashback_growth_redeem_whatsapp": "Récupérer via WhatsApp",
  "cashback_growth_redeem_short": "Récupérer",
  "cashback_growth_decline": "Pas de cashback pour le moment",
  "cashback_growth_card_with_name": "{name}, votre achat a généré du cashback à utiliser dans les restaurants, excursions et attractions de la Serra Gaúcha. Le délai d'utilisation commence lorsque vous le récupérez.",
  "cashback_growth_card_without_name": "Votre achat a généré du cashback à utiliser dans les restaurants, excursions et attractions de la Serra Gaúcha. Le délai d'utilisation commence lorsque vous le récupérez.",
  "partnership_banner_discount": "{value} de remise !",
  "partnership_banner_message": "Achetez maintenant et bénéficiez de {value} de remise de la part de {affiliateName} ! Le coupon <strong>{couponCode}</strong> sera automatiquement appliqué à votre panier.",
  "partnership_banner_continue": "Continuer",
  "recaptcha_validation_error": "Veuillez confirmer que vous n'êtes pas un robot",
  "phone_verification_title": "Vous y êtes presque !",
  "phone_verification_subtitle": "Saisissez le code envoyé par SMS au téléphone",
  "phone_verification_submit_button": "Entrer",
  "invalid_value": "Coupon invalide !",
  "coupon_is_active": "Coupon non applicable pour ces dates.",
  "coupon_has_uses_left": "Le coupon a dépassé la limite maximale d'utilisations.",
  "coupon_has_customer_uses_left": "Oups ! Vous avez déjà utilisé ce coupon le nombre maximal de fois autorisé.",
  "coupon_has_some_products": "Coupon non applicable aux produits sélectionnés !",
  "coupon_purchase_min_amount_cents_not_reached": "Le montant minimum du coupon n'est pas atteint. Ajoutez d'autres articles au panier pour bénéficier de la remise.",
  "coupon_has_some_valid_item": "Coupon non applicable aux produits sélectionnés !",
  "product_package_adder_product_list_title": "Produits",
  "product_package_adder_total": "Total",
  "product_package_adder_selection_step_calendar": "Choisissez une date pour : ",
  "product_package_adder_selection_step_tariff": "Choisissez un tarif pour : ",
  "product_package_adder_selection_step_seat_map": "Choisissez des places pour : ",
  "product_package_adder_selection_step_additional": "Choisissez les suppléments pour : ",
  "product_package_adder_add_to_cart_button": "Ajouter au panier",
  "product_package_adder_complete_selection_description": "Tous les produits du Combo {packageName} avec {productQuantity} activités ont été configurés",
  "product_package_cancel_modal_title": "Voulez-vous fermer le forfait ?",
  "product_package_cancel_modal_description": "La fermeture de la configuration du forfait supprimera tous les produits configurés.",
  "product_package_cancel_modal_action_no": "Non",
  "product_package_cancel_modal_action_yes": "Oui",
  "product_package_error_while_load_package_data": "Une erreur s'est produite lors du chargement des données du forfait. Veuillez contacter l'établissement.",
  "product_package_error_empty_package": "Il semble que ce forfait ne contienne aucun produit disponible à la vente. Veuillez contacter l'établissement.",
  "product_package_error_has_inactive_product": "Oups ! L'un des produits de ce forfait est indisponible à la vente. Veuillez contacter l'établissement.",
  "product_package_error_while_load_package_products_data": "Une erreur s'est produite lors du chargement des produits du forfait. Veuillez contacter l'établissement.",
  "product_package_single_booking_unavailable": "Ce forfait est indisponible pour les options sélectionnées.",
  "product_package_single_booking_quantity_step_title": "Choisissez la quantité de tarifs pour tous les produits du forfait",
  "product_package_single_booking_chosen_date": "Date choisie",
  "product_package_single_booking_additional_fees": "Des frais supplémentaires peuvent s'appliquer",
  "product_package_adder_sold_by": "Vendu par : {owner}",
  "checkout_bin_code_validation_error": "La carte de crédit indiquée n'est pas éligible à l'achat des tarifs sélectionnés. Veuillez utiliser une autre carte.",
  "tds_generic_error": "Erreur lors du traitement du paiement",
  "tds_transaction_failed": "Échec du paiement",
  "tds_transaction_denied": "Paiement refusé",
  "tds_invalid_transactable": "Transaction invalide",
  "currency_warning_message": "Les montants affichés dans d'autres devises sont donnés à titre indicatif. Le débit sera effectué en réal brésilien (BRL).",
  "cart_serviceFee": "Frais de service",
  "cart_serviceFee_tooltip": "Les frais de service servent à la maintenance et à l'exploitation de la plateforme.",
  "product_booking_add_to_cart": "Ajouter au panier",
  "product_booking_date_placeholder": "Sélectionnez une date",
  "product_booking_language_placeholder": "Sélectionnez une langue",
  "product_booking_attribute_placeholder": "Sélectionnez {attribute}",
  "product_booking_attribute_no_option_found": "Aucune option trouvée",
  "product_booking_attribute_loading": "Chargement...",
  "product_booking_attribute_pickup_zone_label": "Lieu de prise en charge",
  "product_booking_tariff_placeholder": "Sélectionnez un tarif",
  "product_booking_tariff_summary": "{count, plural, one {{count, number}x Tarif} other {{count, number}x Tarifs}}",
  "product_booking_additionals_summary": "{count, plural, one {{count, number}x Supplément} other {{count, number}x Suppléments}}",
  "product_booking_service_fee_note": "Des frais de service peuvent s'appliquer",
  "product_booking_no_tariffs": "Aucun tarif disponible pour cette date",
  "product_booking_tariff_max_availability_reached": "La quantité maximale disponible pour ce produit a été atteinte",
  "product_booking_trust_instant_title": "Confirmation instantanée",
  "product_booking_trust_instant_description": "Recevez votre voucher immédiatement par e-mail.",
  "product_booking_trust_secure_title": "Paiement sécurisé",
  "product_booking_trust_secure_description": "Vos données sont protégées.",
  "product_booking_price_in_up_to_installments": "Jusqu'à {count}x",
  "product_booking_price_interest_free": "Sans intérêts",
  "product_booking_price_or_at_sight": "ou {price} comptant",
  "product_booking_price_starting_from": "À partir de",
  "product_booking_price_at_sight_label": "Comptant",
  "product_booking_price_at_sight_compact": "{price} comptant",
  "product_booking_total_label": "TOTAL DE LA RÉSERVATION",
  "product_booking_total_at_sight_suffix": "comptant",
  "product_booking_view_summary": "Voir le récapitulatif",
  "product_booking_additionals": "Sélectionnez un supplément (facultatif)",
  "product_booking_quantity_minus": "Diminuer la quantité",
  "product_booking_quantity_plus": "Augmenter la quantité",
  "product_booking_select_date_first": "Sélectionnez d'abord une date",
  "product_booking_select_language_first": "Sélectionnez d'abord une langue",
  "product_booking_select_tariff_first": "Sélectionnez d'abord un tarif",
  "product_booking_select_time_first": "Sélectionnez d'abord une heure",
  "product_booking_select_seat_map_first": "Terminez d'abord la sélection des places",
  "product_booking_select_additionals_first": "Remplissez d'abord les champs obligatoires des suppléments",
  "product_booking_select_attribute_first": "Sélectionnez d'abord {attribute}",
  "product_booking_trending_reservations": "{count, plural, one {{count, number} personne a réservé} other {{count, number} personnes ont réservé}} au cours des dernières 24h",
  "product_upsell_modal_title": "Ajouté au panier !",
  "product_upsell_modal_description": "Profitez-en pour réserver dès maintenant d'autres expériences incroyables recommandées par nos spécialistes.",
  "product_upsell_sold_by": "Vendu par : {owner}",
  "product_upsell_price_prefix": "À partir de",
  "product_upsell_add_offer": "Ajouter {product}",
  "product_upsell_remove_offer": "Retirer {product}",
  "product_upsell_selected_count": "{count, plural, one {{count, number} article sélectionné} other {{count, number} articles sélectionnés}}",
  "product_upsell_no_thanks": "Non, merci",
  "product_upsell_continue": "Continuer",
  "upsell_booking_cancel_title": "Abandonner l'upsell ?",
  "upsell_booking_cancel_description": "Si vous fermez maintenant, tous les produits supplémentaires seront abandonnés et vous serez redirigé vers le panier avec uniquement le produit principal.",
  "upsell_booking_cancel_action_no": "Continuer",
  "upsell_booking_cancel_action_yes": "Abandonner",
  "upsell_booking_product_list_title": "Produits sélectionnés",
  "upsell_booking_completed_description": "Tous les produits ont été configurés",
  "code_input_value_label": "Valeur {index} sur {length}",
  "checkout_payment_error_declined_title": "Nous n'avons pas pu finaliser votre achat avec cette carte",
  "checkout_payment_error_declined_body": "Pour votre protection, ce paiement a été refusé par notre système de sécurité. Veuillez vérifier les informations de votre carte ou essayer une autre carte.",
  "checkout_payment_error_declined_body_pix": "",
  "checkout_payment_error_issuer_title": "Paiement non autorisé par votre banque",
  "checkout_payment_error_issuer_body": "L'émetteur de votre carte a refusé la transaction. Cela peut être dû à des fonds insuffisants, à des informations de carte incorrectes ou à une restriction de sécurité. Veuillez vérifier les informations saisies et contrôler si votre banque exige une confirmation pour autoriser cet achat. Vous pouvez également essayer une autre carte.",
  "checkout_payment_error_issuer_body_pix": "",
  "checkout_payment_error_secondary_pix": "Payer avec PIX",
  "checkout_payment_error_retry": "Réessayer",
  "checkout_payment_error_expired_title": "Votre commande a expiré",
  "checkout_payment_error_expired_description": "Le délai pour finaliser ce paiement est écoulé. Pour garantir vos produits, il vous suffit de les sélectionner à nouveau et de finaliser votre achat.",
  "checkout_payment_error_expired_retry": "Réessayer"
}
